import React, { useState } from 'react';
import ReactMapGL, { Marker, Popup } from 'react-map-gl';
import coronavirusImg from '../img/Coronavirus.png';

export default function MainMap(props) {
  const [viewport, setViewport] = useState({
    width: '100%',
    height: '100%',
    latitude: 0,
    longitude: 0,
    zoom: 1
  });

  const [showPopup, setShowPopup] = useState({});

  return (
    <ReactMapGL
      {...viewport}
      mapStyle='mapbox://styles/roamiiing/ck8fmmyds2k0u1invifuwwrrb'
      mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
      onViewportChange={setViewport}
      >
        {props.data ? props.data.length > 0 ? props.data.map(e => 
        e.latitude.length > 0 ?
        <div>
        <Marker 
          key={e.key}
          latitude={parseFloat(e.latitude)}
          longitude={parseFloat(e.longitude)}
          offsetLeft={-12}
          offsetTop={-12}
              >
              <img 
                className='virusemoji'
                src={coronavirusImg}
                alt='coronavirus'
                onMouseOver={() => setShowPopup({
                  ...showPopup,
                  [e.key]: {
                    ...e,
                    latitude: parseFloat(e.latitude),
                    longitude: parseFloat(e.longitude),
                  },
                })}
                onMouseLeave={() => setShowPopup({
                  ...showPopup,
                  [e.key]: null,
                })}
                />
        </Marker>
        
        </div> : null) : null : null}
        
        {
          Object.keys(showPopup).map(key => {
            if (showPopup[key]) {
              return (
                <Popup
                  key={key}
                  longitude={showPopup[key].longitude}
                  latitude={showPopup[key].latitude}
                  >
                  <div className='popup'>
                    <p>{showPopup[key]['Combined_Key'] || `${showPopup[key].country}, ${showPopup[key].province}`}</p>
                    <p>Всего случаев: {showPopup[key].total}</p>
                    <p>Смертей: {showPopup[key].deaths}</p>
                    <p>Вылечено: {showPopup[key].cured}</p>
                  </div>
                </Popup> 
              );
            }
            return undefined;
          })
        }


      
        
    </ReactMapGL>
  );
}
